export default __webpack_public_path__ + "42691905c0d0973af1e3182d5e883d30.ttf";